
var permissionDefsSingleton;


const init = function(permissionsData) {
    if (!permissionsData) {
      throw new Error('`init` of `permission-defs` must include permissions data');
    }
    permissionDefsSingleton = permissionsData;
  };
const get = function() {
    if (!permissionDefsSingleton) {
      throw new Error('You must call `init` on permission-defs appglobal before calling `get`');
    }
    return permissionDefsSingleton;
  };



export { get, init };
export default { get, init };
